// components/groupAdmin/feed/feedApi.js
import api from '../../../lib/api';

export const adminFeedApi = {
  listFeed: (groupId) => api.get(`/groups/${groupId}/feed`).then((r) => r.data),

  createArticle: (groupId, formData) =>
    api.post(`/groups/${groupId}/feed`, formData),

  updateFeedItem: (groupId, feedItemId, payload) =>
    api.put(`/groups/${groupId}/feed/${feedItemId}`, payload),

  deleteFeedItem: (groupId, feedItemId) =>
    api.delete(`/groups/${groupId}/feed/${feedItemId}`),

  // Course
  createCourse: (groupId, payload) =>
    api.post(`/groups/${groupId}/feed/courses`, payload),

  getCourseAccess: (groupId, courseId) =>
    api.get(`/groups/${groupId}/feed/courses/${courseId}/access`).then((r) => r.data),

  getCourseBuilder: (groupId, courseId) =>
    api.get(`/groups/${groupId}/feed/courses/${courseId}/builder`).then((r) => r.data),
  
  voteOnPoll: (groupId, feedItemId, payload) =>
  api.post(`/groups/${groupId}/feed/${feedItemId}/poll/vote`, payload).then(r => r.data),

  updateCourse: (groupId, courseId, payload) =>
    api.put(`/groups/${groupId}/feed/courses/${courseId}`, payload),

  addModule: (groupId, courseId, payload) =>
    api.post(`/groups/${groupId}/feed/courses/${courseId}/modules`, payload),

  updateModule: (groupId, courseId, moduleId, payload) =>
    api.put(`/groups/${groupId}/feed/courses/${courseId}/modules/${moduleId}`, payload),

  deleteModule: (groupId, courseId, moduleId) =>
    api.delete(`/groups/${groupId}/feed/courses/${courseId}/modules/${moduleId}`),

  reorderModules: (groupId, courseId, ordered_ids) =>
    api.post(`/groups/${groupId}/feed/courses/${courseId}/modules/reorder`, { ordered_ids }),

  addLesson: (groupId, courseId, moduleId, payload) =>
    api.post(`/groups/${groupId}/feed/courses/${courseId}/modules/${moduleId}/lessons`, payload),

  updateLesson: (groupId, courseId, moduleId, lessonId, payload) =>
    api.put(`/groups/${groupId}/feed/courses/${courseId}/modules/${moduleId}/lessons/${lessonId}`, payload),

  deleteLesson: (groupId, courseId, moduleId, lessonId) =>
    api.delete(`/groups/${groupId}/feed/courses/${courseId}/modules/${moduleId}/lessons/${lessonId}`),

  reorderLessons: (groupId, courseId, moduleId, ordered_ids) =>
    api.post(`/groups/${groupId}/feed/courses/${courseId}/modules/${moduleId}/lessons/reorder`, { ordered_ids }),

  /**
   * Upload a raw course video file to storage.
   * Backend: POST /groups/:groupId/feed/upload-video (form-data: video)
   */
  uploadVideo: async (groupId, file) => {
    const fd = new FormData();
    fd.append('video', file);
    const resp = await api.post(`/groups/${groupId}/feed/upload-video`, fd);
    return resp?.data || {};
  },

  /**
   * Upload lesson video (preferred).
   * Tries course-specific endpoint first, then falls back to /feed/upload-video.
   */
  uploadLessonVideo: async (groupId, courseId, moduleId, lessonId, file) => {
    const fd = new FormData();
    fd.append('video', file);

    // 1) Try course-specific endpoint
    try {
      const r = await api.post(
        `/groups/${groupId}/feed/courses/${courseId}/modules/${moduleId}/lessons/${lessonId}/video`,
        fd
      );
      return r?.data || {};
    } catch (err) {
      const status = err?.response?.status;
      if (status && status !== 404 && status !== 501) throw err;

      // 2) Fallback upload-only route
      const up = await api.post(`/groups/${groupId}/feed/upload-video`, fd);
      const d = up?.data || {};

      // 3) Best-effort persist onto lesson
      try {
        await api.put(
          `/groups/${groupId}/feed/courses/${courseId}/modules/${moduleId}/lessons/${lessonId}`,
          {
            video_path: d.path || null,
            video_url: d.url || null,
            video_url_expires_at: d.url_expires_at || null,
            video_name: d.name || file?.name || null,
            video_content_type: d.content_type || file?.type || null,
            video_size: d.size ?? file?.size ?? null,
          }
        );
      } catch (persistErr) {
        console.warn('uploadLessonVideo: uploaded but could not persist onto lesson yet:', persistErr);
      }

      return d;
    }
  },
};
